import httpService from "./httpService";

export default {
  findAllByHcCaseMasterId(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get(`/hcDieuXeScheduleView/findAllByHcCaseMasterId`, {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/hcDieuXeScheduleViewService.js